module.exports = __webpack_public_path__ + "static/media/logo-removebg-preview (1).4305906b.png";